export default __webpack_public_path__ + "static/media/icon_sort.8988a1fe.svg";